import { useState } from "react";
import { Check, ChevronDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

/** Columns pill — lives in the view rail; same menu look as the header / pill filters (blue check on shown columns). */
export default function ColumnPicker({ columns, visible, onToggle, onReset }) {
  const [open, setOpen] = useState(false);
  const hidden = columns.length - columns.filter((c) => visible.includes(c.key)).length;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid="column-picker-btn" data-active={hidden ? "1" : "0"}
                className="inline-flex items-center gap-1 whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium text-slate-500 transition-colors hover:text-slate-800">
          Columns<ChevronDown className="h-3 w-3 opacity-60" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-56 p-0" data-testid="column-picker-menu">
        <div className="max-h-[420px] overflow-auto py-1">
          <button onClick={onReset} data-testid="column-picker-reset"
                  className="flex w-full items-center justify-between px-2.5 py-1.5 text-xs text-slate-600 hover:bg-slate-50">
            Default columns
          </button>
          {columns.map((c) => {
            const on = visible.includes(c.key);
            return (
              <button key={c.key} onClick={() => onToggle(c.key)} data-testid={`column-toggle-${c.key}`} data-on={on ? "1" : "0"}
                      className={`flex w-full items-center justify-between gap-2 px-2.5 py-1.5 text-xs hover:bg-slate-50 ${on ? "text-[#007BFF]" : "text-slate-600"}`}>
                <span className="truncate">{c.label}</span>
                {on && <Check className="h-3 w-3" />}
              </button>);
          })}
        </div>
      </PopoverContent>
    </Popover>
  );
}
